<template>
  <div class="button-preview">
    <button
      type="button"
      class="btn"
    >
      <IconPreviewUpload
        width="25px"
        height="25px"
      />
    </button>
  </div>
</template>

<script>
import IconPreviewUpload from "@/components/atoms/icons/IconPreviewUpload.vue"

export default {
  name: "ButtonPreviewUpload",
  components: {
    IconPreviewUpload,
  },
}
</script>
